module.exports = __webpack_public_path__ + "img/application_trafo.19bde24e.jpg";